var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_160_369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.3736 24 0 18.6264 0 12C0 5.3736 5.3736 0 12 0C18.6264 0 24 5.3736 24 12C24 18.6264 18.6264 24 12 24Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.637 8.13819C19.4546 7.44699 18.9146 6.90459 18.2282 6.71979C16.985 6.38379 12.0026 6.38379 12.0026 6.38379C12.0026 6.38379 7.01783 6.38379 5.77703 6.71979C5.09063 6.90459 4.55063 7.44699 4.36823 8.13819C4.03223 9.38859 4.03223 11.9998 4.03223 11.9998C4.03223 11.9998 4.03223 14.611 4.36583 15.8614C4.54823 16.5526 5.08823 17.095 5.77463 17.2798C7.01783 17.6158 12.0002 17.6158 12.0002 17.6158C12.0002 17.6158 16.985 17.6158 18.2258 17.2798C18.9122 17.095 19.4522 16.5526 19.6346 15.8614C19.9682 14.611 19.9682 11.9998 19.9682 11.9998C19.9682 11.9998 19.9682 9.38859 19.637 8.13819ZM10.3706 14.3686V9.63099L14.5346 11.9998L10.3706 14.3686Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_160_369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.bacec6353b79cebec4b682407cd7713a.svg";
export { ForwardRef as ReactComponent };